export default __webpack_public_path__ + "static/media/gallery-wip-grenade cap_08.a6861d95.jpg";